import Immutable from 'immutable';
import React from 'react';
import Cross from '../../forms/cross';

const EMPTY_LIST = Immutable.List([]);

export default function CrossDefinition() {
	if (!(this instanceof CrossDefinition)) {
		return new CrossDefinition();
	}

	let items;
	let isVisibleCallback;
	let isHidden;
	let alignItems;
	let justifyContent;
	let validator;

	this.setAlignItems = function(value) {
		alignItems = value;
		return this;
	};

	this.setJustifyContent = function(value) {
		justifyContent = value;
		return this;
	};

	this.setValidator = function(value) {
		if (value && !value.isContextValidator) {
			throw 'Only context validator allowed in CrossDefinition';
		}
		validator = value;
		return this;
	};

	const validate = function(errors, ctx, itemName) {
		if (validator) {
			validator.validate(errors, ctx, itemName);
		}
	};


	this.setItems = function(value) {
		items = Immutable.List(value);
		items.forEach(item => {
			item._parentDefinition = this;
		});
		return this;
	};

	this.setVisible = function(value) {
		if (typeof value === 'function') {
			isHidden = false;
			isVisibleCallback = value;
		} else {
			isHidden = !value;
			isVisibleCallback = null;
		}
		return this;
	};

	this.getItems = function() {
		return items;
	};

	this.validateAll = function(ctx, errors) {
		if (isHidden || (isVisibleCallback && !isVisibleCallback(ctx))) {
			return null;
		}
		validate(errors, ctx);
		(items || EMPTY_LIST).forEach(item => {
			item.validateAll(ctx, errors);
		});
	};

	this.validateOnChange = function(ctx, errors, itemName) {
		validate(errors, ctx, itemName);
		if (this._parentDefinition && this._parentDefinition.validateOnChange) {
			this._parentDefinition.validateOnChange(ctx, errors, itemName)
		}
	};

	this.render = function(ctx, key = 0) {
		if (isHidden || (isVisibleCallback && !isVisibleCallback(ctx))) {
			return null;
		}
		return (
			<Cross key={key} alignItems={alignItems} justifyContent={justifyContent}>
				{
					(items || EMPTY_LIST).map((item, index) => item.render(ctx, index))
				}
			</Cross>
		)
	};
}
